import { useEffect, useState } from "react";

// Visitor's ad-cookie choice: "personalized" | "non-personalized" | "rejected" | null.
const KEY = "ad-consent";

export const getConsent = () => {
    try { return localStorage.getItem(KEY); } catch { return null; }
};

export const setConsent = (value) => {
    try { localStorage.setItem(KEY, value); } catch { /* ignore */ }
    window.dispatchEvent(new CustomEvent("ad-consent", { detail: value }));
};

// Ads may load for both "personalized" and "non-personalized" (contextual) choices.
export const adsEnabled = (value) => value === "personalized" || value === "non-personalized";

export function useConsent() {
    const [c, setC] = useState(getConsent());
    useEffect(() => {
        const h = (e) => setC(e.detail);
        window.addEventListener("ad-consent", h);
        return () => window.removeEventListener("ad-consent", h);
    }, []);
    return c;
}
